import React, { useEffect, useState } from "react";
import "../App.scss";
import "./NewPatient.scss";
import noPain from "../assets/images/noPain.png";
import PainAssessment from "../components/PainAssessment";
const NewPatient = () => {
  const initialFormData = {
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    gender: "",
    dateOfBirth: "",
    phoneNumber: "",
    languages: "",
    primaryLanguage: "",
    additionalDiagnosis: "",
    painFrequencyinLast6months: "Never",
    diagnosis: {
      osteoarthritis: {
        rightHip: "No Pain",
        leftHip: "No Pain",
        rightAnkle: "No Pain",
        leftAnkle: "No Pain",
        rightKnee: "No Pain",
        leftKnee: "No Pain",
      },
      arthritis: {
        rightHip: false,
        leftHip: false,
        rightAnkle: false,
        leftAnkle: false,
        rightKnee: false,
        leftKnee: false,
      },
    },
    painSeverityIn6months: {
      leftHip: "No Pain",
      rightHip: "No Pain",
      leftKnee: "No Pain",
      rightKnee: "No Pain",
      leftAnkle: "No Pain",
      rightAnkle: "No Pain",
    },
    clinicalImpressions: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const [errors, setErrors] = useState({});

  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");

  const [showModal, setShowModal] = useState(false);
  const token = localStorage.getItem("token");
  const validate = () => {
    const newErrors = {};
    const nameRegex = /^[a-zA-Z\s\-']+$/; // Allows letters, spaces, hyphens, and apostrophes
    const phoneRegex = /^\d{10,15}$/; // Numeric, 10-15 digits

    // Name Validations
    if (!formData.firstName.trim()) {
      newErrors.firstName = "First Name is required.";
    } else if (!nameRegex.test(formData.firstName.trim())) {
      newErrors.firstName =
        "First Name can only contain letters, spaces, hyphens, or apostrophes.";
    }

    if (formData.middleName && !nameRegex.test(formData.middleName.trim())) {
      newErrors.middleName =
        "Middle Name can only contain letters, spaces, hyphens, or apostrophes.";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last Name is required.";
    } else if (!nameRegex.test(formData.lastName.trim())) {
      newErrors.lastName =
        "Last Name can only contain letters, spaces, hyphens, or apostrophes.";
    }

    if (!formData.email) newErrors.email = "Email address is required.";
    // Gender Validation
    if (!formData.gender) newErrors.gender = "Gender selection is required.";

    // Date of Birth Validation
    if (!formData.dateOfBirth) {
      newErrors.dateOfBirth = "Date of Birth is required.";
    } else if (new Date(formData.dateOfBirth) >= new Date()) {
      newErrors.dateOfBirth = "Date of Birth must be in the past.";
    }

    // Phone Number Validation
    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone Number is required.";
    } else if (!phoneRegex.test(formData.phoneNumber.trim())) {
      newErrors.phoneNumber =
        "Phone Number must be between 10-15 digits and contain only numbers.";
    }

    // Primary Language Validation
    if (!formData.primaryLanguage.trim()) {
      newErrors.primaryLanguage = "Primary Language is required.";
    } else if (!nameRegex.test(formData.primaryLanguage.trim())) {
      newErrors.primaryLanguage =
        "Primary Language can only contain letters, spaces, hyphens, or apostrophes.";
    }
    if (!formData.painFrequencyinLast6months)
      newErrors.painFrequencyinLast6months =
        "Pain history selection is required.";
    if (!formData.clinicalImpressions.trim())
      newErrors.clinicalImpressions = "Clinical Impressions are required.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    const newErrors = validate();
    setErrors(newErrors);
    const requestData = {
      ...formData,
    };
    console.log("Sending to backend:", requestData);
    if (Object.keys(newErrors).length === 0) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/patients/create-profile`,
          {
            method: "POST",
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(requestData),
          }
        );

        const data = await response.json();

        if (response.ok) {
          setFormData(initialFormData);
          setErrors({});
          setSuccessMessage(data.message);
          setShowModal(true);
          setTimeout(() => {
            setSuccessMessage("");
            setShowModal(false);
          }, 3000);
        } else {
          console.log("Error ", data);
          setSuccessMessage(data.message + ". Please review the form again.");
          setShowModal(true);
          setTimeout(() => {
            setSuccessMessage("");
            setShowModal(false);
          }, 3000);
          console.error("Error:", data.message);
        }
      } catch (error) {
        console.error("Error submitting the form ", error);
      }
    }
  };
  console.log("FormData ", formData);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    //setFormError((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };
  useEffect(() => {
    console.log("Test ", typeof formData["languages"]);
  }, [formData["languages"]]);
  const handleDiagnosisChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      diagnosis: {
        ...prev.diagnosis,
        osteoarthritis: {
          ...prev.diagnosis.osteoarthritis,
          [field]: value,
        },
      },
    }));
  };

  const handleArthritisChange = (field) => {
    console.log("Field ", field);
    setFormData((prev) => ({
      ...prev,
      diagnosis: {
        ...prev.diagnosis,
        arthritis: {
          ...prev.diagnosis.arthritis,
          [field]: !prev.diagnosis.arthritis[field],
        },
      },
    }));
  };

  const formatField = (field) => {
    return field
      .replace(/([A-Z])/g, " $1") // Add space before uppercase letters
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
  };

  const handlePainAssessmentChange = (joint, value) => {
    console.log("Is it correct ? ", joint, value);

    setFormData((prev) => {
      const updatedPainSeverity = {
        ...prev.painSeverityIn6months,
        [joint]: value,
      };

      console.log("Updated State: ", updatedPainSeverity);

      return {
        ...prev,
        painSeverityIn6months: updatedPainSeverity,
      };
    });
  };

  return (
    <div className="pageContainer" style={{ background: "#FAFBFC" }}>
      <div className="pageHeader">
        <div className="h1">
          <a href="/patients">Patients</a> &gt; Add New Patient
        </div>
      </div>
      <div style={{ padding: "1.57rem 2.2rem" }}>
        <div className="h2" style={{ paddingBottom: "1.1rem" }}>
          Primary Information
        </div>
        <div className="row centerAlign spaceBetween">
          <div className="h3" style={{ flex: 0.1 }}>
            Full Name
          </div>
          <div className="row" style={{ flex: 0.9 }}>
            <div style={{ flex: 1 }}>
              <input
                className="patientFormInput b2"
                type="text"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                name="firstName"
              />
              {errors.firstName && <p className="error">{errors.firstName}</p>}
            </div>
            <div style={{ flex: 1 }}>
              <input
                className="patientFormInput b2"
                type="text"
                placeholder="Middle Name"
                value={formData.middleName}
                onChange={handleChange}
                name="middleName"
              />
              {errors.middleName && (
                <p className="error">{errors.middleName}</p>
              )}
            </div>
            <div style={{ flex: 1 }}>
              <input
                className="patientFormInput b2"
                type="text"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                name="lastName"
              />
              {errors.lastName && <p className="error">{errors.lastName}</p>}
            </div>
          </div>
        </div>

        <div className="row centerAlign spaceBetween">
          <div className="h3" style={{ flex: 0.1 }}>
            Email
          </div>
          <div className="formRadio row centerAlign" style={{ flex: 0.9 }}>
            <input
              className="patientFormInput b2"
              type="text"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              name="email"
            />
          </div>
        </div>

        <div className="row centerAlign spaceBetween">
          <div className="h3" style={{ flex: 0.1 }}>
            Gender
          </div>
          <div className="formRadio row centerAlign" style={{ flex: 0.9 }}>
            {["Male", "Female", "Non-Binary", "Prefer not to say", "Other"].map(
              (gender) => (
                <React.Fragment key={gender}>
                  <input
                    name="gender"
                    value={gender}
                    id={`gender${gender}`}
                    type="radio"
                    checked={formData.gender === gender}
                    onChange={handleChange}
                  />
                  <label className="b2" htmlFor={`gender${gender}`}>
                    {gender}
                  </label>
                </React.Fragment>
              )
            )}
            {errors.gender && <p className="error">{errors.gender}</p>}
          </div>
        </div>
        <div className="row centerAlign spaceBetween">
          <div className="h3" style={{ flex: 0.1 }}>
            Date of birth
          </div>
          <div style={{ flex: 0.9 }} className="row centerAlign">
            <input
              className="patientFormInput"
              name="dateOfBirth"
              id="dateOfBirth"
              type="date"
              value={formData.dateOfBirth}
              onChange={handleChange}
            />
            {errors.dateOfBirth && (
              <p className="error">{errors.dateOfBirth}</p>
            )}
          </div>
        </div>
        <div className="row centerAlign spaceBetween">
          <div style={{ flex: 0.1 }} className="h3">
            Phone number
          </div>
          <div style={{ flex: 0.9 }} className="row centerAlign">
            <input
              className="patientFormInput"
              type="text"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
            />
            {errors.phoneNumber && (
              <p className="error">{errors.phoneNumber}</p>
            )}
          </div>
        </div>
        <div className="row centerAlign spaceBetween">
          <div style={{ flex: 0.1 }} className="h3">
            Languages
          </div>
          <div style={{ flex: 0.9 }}>
            <input
              className="patientFormInput"
              type="text"
              name="languages"
              value={formData.languages}
              onChange={handleChange}
              placeholder="Enter languages, separated by commas"
            />
          </div>
        </div>
        <div className="row centerAlign spaceBetween">
          <div style={{ flex: 0.1 }} className="h3">
            Primary language
          </div>
          <div style={{ flex: 0.9 }} className="row centerAlign">
            <input
              className="patientFormInput"
              type="text"
              name="primaryLanguage"
              value={formData.primaryLanguage}
              onChange={handleChange}
            />
            {errors.primaryLanguage && (
              <p className="error">{errors.primaryLanguage}</p>
            )}
          </div>
        </div>
      </div>

      <div style={{ padding: "1.57rem 2.2rem" }}>
        <div className="h2" style={{ marginBottom: "0.5rem" }}>
          Diagnosis
        </div>
        <div>
          <div className="h3">Osteoarthritis</div>
          <div className="col" style={{ marginBottom: "1.1rem" }}>
            {[
              "rightHip",
              "leftHip",
              "rightAnkle",
              "leftAnkle",
              "rightKnee",
              "leftKnee",
            ].map((field) => (
              <div className="row space-between osteoCheck" key={field}>
                <label className="b2 textGrey">{formatField(field)}</label>
                <select
                  value={formData.diagnosis.osteoarthritis[field]}
                  onChange={(e) => handleDiagnosisChange(field, e.target.value)}
                >
                  <option value="No Pain">No Pain</option>
                  <option value="Mild">Mild</option>
                  <option value="Moderate">Moderate</option>
                  <option value="Severe">Severe</option>
                </select>
              </div>
            ))}
          </div>
          <div>
            <div className="h3">Arthritis</div>
            <div className="row wrapRow">
              {[
                "rightHip",
                "leftHip",
                "rightAnkle",
                "leftAnkle",
                "rightKnee",
                "leftKnee",
              ].map((field, index) => (
                <React.Fragment key={field}>
                  <div className="arthritisCheck">
                    <input
                      type="checkbox"
                      id={field}
                      checked={formData.diagnosis.arthritis[field]} // ✅ Access object property
                      onChange={() => handleArthritisChange(field)} // ✅ Toggle specific key
                    />
                    <label htmlFor={field}>
                      {field
                        .replace(/([A-Z])/g, " $1")
                        .replace(/^./, (str) => str.toUpperCase())}
                    </label>
                  </div>
                  {index === 2 && <div style={{ width: "100%" }}></div>}{" "}
                  {/* Acts as a line break */}
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="additionalDiagnosis row centerAlign">
            <label style={{ flex: 0.1 }} className="h3">
              Additional <br />
              Diagnosis
            </label>
            <textarea
              className="patientFormInput"
              rows={4}
              cols={10}
              value={formData.additionalDiagnosis}
              name="additionalDiagnosis"
              onChange={handleChange}
            />
          </div>
          <div className="formRadio">
            <div className="h3">
              Over the last 6 months, how often have you experienced any hip,
              knee, or ankle pain during walking?
            </div>
            {[
              "Never",
              "Rarely (once a month)",
              "Sometimes (about once a week)",
              "Often (multiple times a week)",
              "Daily (every day)",
            ].map((option) => (
              <React.Fragment key={option}>
                <input
                  name="painFrequencyinLast6months"
                  value={option}
                  id={`painFrequencyinLast6months${option}`}
                  type="radio"
                  checked={formData.painFrequencyinLast6months === option}
                  onChange={handleChange}
                />
                <label htmlFor={`painFrequencyinLast6months${option}`}>
                  {option}
                </label>
              </React.Fragment>
            ))}
            {/* <input name="painHistory" id="painHistoryNever" type="radio"/><label for="painHistoryNever">Never</label>
                    <input name="painHistory" id="painHistoryRarely" type="radio"/><label for="painHistoryRarely">Rarely(Once a month)</label>
                    <input name="painHistory" id="painHistorySometimes" type="radio"/><label for="painHistorySometimes">Sometimes (about once a week)</label>
                    <input name="painHistory" id="painHistoryOften" type="radio"/><label for="painHistoryOften">Often (multiple times a week)</label>
                    <input name="painHistory" id="painHistoryDaily" type="radio"/><label for="painHistoryDaily">Daily (every day)</label> */}
          </div>
          <div>
            <div className="h3">
              On average over the last 6 months, how severe has the pain been?
            </div>
            <PainAssessment
              prefix="avgPain"
              onChange={handlePainAssessmentChange}
              selectedValue={formData.painSeverityIn6months}
            />
          </div>
          <div style={{ marginBottom: "6.3rem" }}>
            <div className="h3">Clinical Impressions</div>
            <textarea
              className="patientFormTextArea"
              rows={10}
              cols={50}
              name="clinicalImpressions"
              value={formData.clinicalImpressions}
              onChange={handleChange}
            ></textarea>
            {errors.clinicalImpressions && (
              <p className="error">{errors.clinicalImpressions}</p>
            )}
          </div>
          {showModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100vh",
                background: "rgba(0, 0, 0, 0.5)",
                zIndex: 1000,
              }}
            >
              {successMessage && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    padding: "25px",
                    background: "white",
                    transform: "translate(-50%, -50%)",
                  }}
                >
                  <p className="h1">{successMessage}</p>
                </div>
              )}
            </div>
          )}
          <div>
            <button
              className="button1 h3 white"
              style={{ background: "var(--hippieBlue" }}
              onClick={() => handleSubmit()}
            >
              SAVE
            </button>
            <button
              className="button1 h3 hippiBlue"
              style={{ background: "transparent" }}
            >
              CANCEL
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPatient;
